import * as React from 'react';
import * as styles from './SidebarBlock.css';

export const SidebarBlock: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
